module.exports = __webpack_public_path__ + "static/media/chevron-down.fc0887aa.svg";